import { findByLabelText } from '@testing-library/react';
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import levlrLogo from "../../img/LEVLR Logo_CMYK.png";
import termsOfUse from "../../img/TermsOfUse.pdf"
import avatarLogo from '../../img/admin-icon-green.png';
import privacyPolicy from "../../img/PrivacyPolicy.pdf"
import axios from 'axios'
import LogoutButton from '../logout/logout.jsx';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';

import Mailgun from 'mailgun.js';
import FormData from 'form-data';


const MainPanel = props => {
    const userData = useSelector(state => state.user)
    const userName = useSelector(state => state.user.name)
    const userEmail = useSelector(state => state.user.email)
    const userActive = useSelector(state => state.user.isActive)


    const imgResize = {
        width: '70%',
        height: 'auto'
    }

    const formStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -40%)',
        backgroundColor: '#FFFFFF',
        opacity: '0.98',
        width: '90%',
        maxWidth: '600px',
        padding: '2rem',
        borderRadius: '16px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
        display: 'flex',
        flexDirection: 'column',
        gap: '1.5rem',
        zIndex: '9999',
        fontFamily: 'Arial, sans-serif',
      };
      
      const contentWrapper = {
        display: 'flex',
        flexDirection: 'column',
        gap: '1.25rem',
      };
      
      const h1Style = {
        textAlign: 'center',
        textTransform: 'uppercase',
        color: '#00B3B5',
        fontSize: '1.5rem',
        margin: 0,
      };
      
      const subtitleStyle = {
        textAlign: 'center',
        color: '#555555',
        fontSize: '0.95rem',
        margin: 0,
      };
      
      const questionaireStyle = {
        display: 'flex',
        flexDirection: 'column',
        gap: '1.25rem',
      };
      
      const individualStyle = {
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5rem',
      };
      
      const blockStyle = {
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5rem',
      };
      
      const spanStyle = {
        fontWeight: 600,
        color: '#555555',
      };
      
      const inputStyle = {
        padding: '0.7rem 1rem',
        borderRadius: '8px',
        border: '1px solid #ccc',
        fontSize: '1rem',
        outline: 'none',
        color: '#555555',
      };
      
      const textareaStyle = {
        ...inputStyle,
        resize: 'vertical',
      };
      
      const buttonContainer = {
        display: 'flex',
        justifyContent: 'center',
      };
      
      const submitStyle = {
        backgroundColor: '#00B3B5',
        color: '#FFFFFF',
        padding: '0.9rem 2rem',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        fontSize: '1rem',
        fontWeight: 'bold',
        transition: 'background 0.3s ease',
      };
      
      submitStyle[":hover"] = {
        backgroundColor: '#009395',
      };
      const feedbackButton = {
        width: '120px',
        marginLeft: '24px',
        marginRight: '24px',
        backgroundColor: '#00B3B5',
        borderRadius: '0px',
        height: '36px',
        padding: '4px 24px'
    }
    const termsButton = {
        display: 'flex',
        width: 'auto',
        background: 'none',
        borderRadius: '0px',
        height: 'auto',
        padding: '4px 24px',
        alignItems: 'center',
        color: '#555555',
        textDecoration: 'none'
    }
      const xButton = {
        position: 'absolute',
        right: '1rem',
        top: '1rem',
        background: 'none',
        border: 'none',
        fontSize: '1.5rem',
        color: '#555555',
        cursor: 'pointer',
      };
      
    const mailgun = new Mailgun(FormData);
    const mg = mailgun.client({username: 'Jeffrey Diem', key: process.env.REACT_APP_MG_API});

    //open/close state
    const [open, setOpen] = useState(false);

    //object declaration and states
    const [question1, setQuestion1] = useState(
        0
    );

    const [question2, setQuestion2] = useState(
        ''
    );

    const [question3, setQuestion3] = useState(
        ''
    );

    const [question4, setQuestion4] = useState(
        ''
    );

    const [feedbackData, setFeedbackData] = useState({
        date_created: '',
        rating: 0, 
        helpful: '', 
        recommend: '', 
        comments: '', 
        user_name: '',
        user_id: ''
    });

    //Handlers
    const handlequestion1 = e => {
        setQuestion1(
            e.target.value
        )
    }

    const handlequestion2 = e => {
        setQuestion2(
            e.target.value
        )
    }

    const handlequestion3 = e => {
        setQuestion3(
            e.target.value
        )
    }

    const handlequestion4 = e => {
        setQuestion4(
            e.target.value
        )
    }

    function renderFeedbackButton() {
        if (userActive === false) {
            return (
                <div></div>
            )
        }
        if (userActive === true) {
            return (
                <Button 
                style={feedbackButton}
                variant="contained"
                onClick={() => setOpen(true)}
                >
                    Feedback
                </Button> 
            ) 
        }
    }    
    
    const newFeedback = async (e) => {
        e.preventDefault();
    
        const now = new Date().toLocaleString();
        const feedbackData = {
            date: now,
            rating: question1,
            helpful: question2,
            recommend: question3,
            comments: question4,
            userId: userData._id,
            userName,
            userEmail
        };
    
        try {
            const response = await axios.post(
                process.env.REACT_APP_FEEDBACK,
                feedbackData
            );
    
            if (response.data.success) {
                alert("Thank you for submitting your feedback!");
                setOpen(false);
            } else {
                console.error("Backend error:", response.data.error);
                alert("There was an error submitting your feedback. Please try again.");
            }
        } catch (err) {
            console.error("Feedback submission failed:", err);
            alert("There was an error submitting your feedback. Please try again.");
        }
    };
    
    return (

        <div className={'header-container'}>

            <div className={'header-start'}>

                <div className={'empty-div'}>
                    
                </div>

                <NavLink to="/accounts" className={'user-container'}>
                    
                <div className="profile-info-container">
                    <img
                        src={avatarLogo}
                        alt="User Logo"
                        style={{ width: '32px', height: 'auto', border: 'none'}}
                    />
                    <div className="profile-info-text">
                        <strong className="strong-style">{userData.name}</strong>
                        <p className="p-style">{userData.email}</p>
                    </div>
                </div>

                </NavLink>
                {/* User Details */}

            </div>

            <div className={'header-middle'}>
                <img src={levlrLogo} className={'levlr-logo-resize'}></img>
            </div>

            <div className={'header-end'}>
                <a 
                    style={termsButton}
                    href={termsOfUse}
                    target="_blank"
                >
                        Terms of Use 
                </a> 
                <a 
                    style={termsButton}
                    href={privacyPolicy}
                    target="_blank"                
                >
                        Privacy Policy
                </a> 
            

            {renderFeedbackButton()}
            <LogoutButton />

            <Modal 
            open={open}
            >
                <form onSubmit={(e) => newFeedback(e)} style={formStyle}>
                <button style={xButton} onClick={() => setOpen(false)}>×</button>

                <div style={contentWrapper}>
                    <h1 style={h1Style}>We Value Your Feedback</h1>
                    <p style={subtitleStyle}>Please complete this short questionnaire to help us improve.</p>

                    <div style={questionaireStyle}>
                    <div style={individualStyle}>
                        <label style={spanStyle} htmlFor="rating">
                        How would you rate the overall ease of use of Levlr? <small>(1–5)</small>
                        </label>
                        <input
                        style={inputStyle}
                        type="number"
                        id="rating"
                        name="rating"
                        min="1"
                        max="5"
                        onChange={handlequestion1}
                        />
                    </div>

                    <div style={individualStyle}>
                        <label style={spanStyle} htmlFor="helpful">
                        Did Levlr provide actionable data that you found helpful?
                        </label>
                        <select style={inputStyle} id="helpful" name="helpful" onChange={handlequestion2}>
                        <option value="">Select an option</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        </select>
                    </div>

                    <div style={individualStyle}>
                        <label style={spanStyle} htmlFor="recommend">
                        Would you recommend Levlr to a colleague?
                        </label>
                        <select style={inputStyle} id="recommend" name="recommend" onChange={handlequestion3}>
                        <option value="">Select an option</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        </select>
                    </div>

                    <div style={blockStyle}>
                        <label style={spanStyle} htmlFor="comments">
                        Please let us know any additional feedback.
                        </label>
                        <textarea
                        style={textareaStyle}
                        rows="5"
                        id="comments"
                        name="comments"
                        onChange={handlequestion4}
                        />
                    </div>

                    <div style={buttonContainer}>
                        <button style={submitStyle} type="submit">Submit Feedback</button>
                    </div>
                    </div>
                </div>
                </form>
            </Modal>
            </div>

        </div>       
    )

}

export default MainPanel